import { Title } from '@angular/platform-browser';
import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
} from '@angular/animations';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { lastValueFrom, map, throwError } from 'rxjs';
import { PageItem } from 'src/app/models/portal';
import {
  AuthenticationService,
  ApiService,
} from '../../../../../shared/services';
import { UserDashboardService } from '../../../../../shared/services/user-dashboard.service';
import { PromptingService } from 'src/app/shared/services';
import { MailServiceStatus } from '../../portal.model';
import {
  PortalViewPageStatusEnum,
  SharedPortalViewService,
} from '../shared-portal-view.service';

export enum PortalNavigatorEnum {
  site_settings,
  pages,
  site_apperances,
}

export enum PagesFilterNavigatorEnum {
  all,
  published,
  draft,
}

@Component({
  selector: 'app-portal-domains',
  templateUrl: './portal-domains.component.html',
  styleUrls: ['./portal-domains.component.css'],
  animations: [
    trigger('divStateDraft', [
      state(
        'in',
        style({ backgroundColor: 'red', transform: 'translateX(0)' }),
      ),

      transition('void => *', [
        animate(
          1000,
          keyframes([
            style({ opacity: 0, transform: 'translateY(-100%)' }),
            style({ opacity: 1, transform: 'translateY(15px)' }),
            style({ opacity: 1, transform: 'translateY(0)' }),
          ]),
        ),
      ]),
      transition('* => void', [
        animate(
          500,
          keyframes([
            style({ opacity: 1, transform: 'translateY(0)' }),
            style({ opacity: 1, transform: 'translateY(-15px)' }),
            style({ opacity: 0, transform: 'translateY(100%)' }),
          ]),
        ),
      ]),
    ]),
    trigger('divState', [
      state(
        'in',
        style({ backgroundColor: 'red', transform: 'translateX(0)' }),
      ),

      transition('void => *', [
        animate(
          1000,
          keyframes([
            style({ opacity: 0, transform: 'translateY(-100%)' }),
            style({ opacity: 1, transform: 'translateY(15px)' }),
            style({ opacity: 1, transform: 'translateY(0)' }),
          ]),
        ),
      ]),
      transition('* => void', [
        animate(
          0,
          keyframes([
            style({ opacity: 1, transform: 'translateY(0)' }),
            style({ opacity: 1, transform: 'translateY(-15px)' }),
            style({ opacity: 0, transform: 'translateY(100%)' }),
          ]),
        ),
      ]),
    ]),
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0s ease-in', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class PortalDomainsComponent implements OnInit {
  mailServiceStatus: MailServiceStatus = MailServiceStatus.not_configured;
  userMailOptionsSize: number;
  userMailOptions: any;

  constructor(
    private route: Router,

    private api: ApiService,

    public sharedPortalViewService: SharedPortalViewService,
    private title: Title,
    private prompting: PromptingService,
  ) {
    this.sharedPortalViewService.setPageStatus(
      PortalViewPageStatusEnum.domains,
    );
    this.handleError = this.handleError.bind(this);
  }

  async ngOnInit() {
    // await this.getPortalMailingServiceStatus();
    await this.sharedPortalViewService.getUserDomains();
    this.title.setTitle(
      this.sharedPortalViewService.currentWebsite.website.label +
        ' > ' +
        'Domains',
    );
  }

  async setDomainMailingService() {
    if (this.mailServiceStatus == MailServiceStatus.not_configured) {
      this.route.navigateByUrl('profile/mailing');
    } else {
      this.prompting.success('All done!', '', 'md');
      let mailingEmail = '';
      //
      // .queue([
      //   {
      //     html:
      //       'Choose an outgoing email for this Domain.<br>This is the email that your subscribers<br>will see in the FROM field <div class="input-group mt-3"><select style="height: 3.2em;" id="mailingEmail" class="form-control" placeholder="Username" aria-describedby="basic-addon2"><option value="noreply">noreply</option><option value="newsletter">newsletter</option><option value="subscribe">subscribe</option><option value="marketing">marketing</option></select><div class="input-group-append"><span class="input-group-text" id="basic-addon2">' +
      //       '@' +
      //       this.sharedPortalViewService.currentWebsite.website.siteUrl.replace(
      //         'www.',
      //         ''
      //       ) +
      //       '</span></div>',
      //     preConfirm: () => {
      //       mailingEmail =
      //         (document.getElementById('mailingEmail') as HTMLInputElement)
      //           .value +
      //         '@' +
      //         this.sharedPortalViewService.currentWebsite.website.siteUrl.replace(
      //           'www.',
      //           ''
      //         );
      //     },
      //   },
      //   {
      //     html: 'Pick a SMTP Account to use for this Domain<br>You can Configure additional accounts under <a href="profile/mailing">SMTP Settings</a>',
      //     input: 'select',
      //     inputOptions: this.userMailOptions,
      //     allowOutsideClick: false,
      //     inputAttributes: {
      //       style:
      //         'height: 2.7em;border-radius: 5px;border: 1px solid #ced4da;',
      //       autocapitalize: 'off',
      //     },
      //     confirmButtonText: 'Proceed',
      //     showLoaderOnConfirm: true,
      //     preConfirm: (mailingService) => {
      //       return this.api
      //         .updatePortalMail(
      //           +this.sharedPortalViewService.currentWebsite.id,
      //           +mailingService,
      //           mailingEmail,
      //           this.handleError
      //         )
      //         .toPromise()
      //         .then((response) => {
      //           this.mailServiceStatus = MailServiceStatus.pending;
      //           Swal.fire({
      //             icon: 'success',
      //             title: 'All done!',
      //             confirmButtonText: 'OK!',
      //           });
      //         })
      //         .catch((error) => {
      //           Swal.showValidationMessage(`Request failed: ${error}`);
      //         });
      //     },
      //   },
      // ]);
    }
  }

  private handleError(error: HttpErrorResponse) {
    const msg = 'Something went wrong in portal service.';
    // return an observable with a user friendly message
    return throwError(error.message || msg);
  }

  async getMailingData() {
    const data = await this.api.getUserMailServices().toPromise();
    const userMailService: Map<
      number,
      { mailServiceId: number; mailServiceName: string; apiKey: string }
    > = data.data;
    this.userMailOptions = new Map();

    for (const key in userMailService) {
      if (Object.prototype.hasOwnProperty.call(userMailService, key)) {
        const a = userMailService[key];
        this.userMailOptions.set(a.mailServiceId, a.mailServiceName);
      }
    }
    this.userMailOptionsSize = this.userMailOptions.size;
  }

  // async getPortalMailingServiceStatus() {
  //   await this.getMailingData();

  //   if (this.sharedPortalViewService.currentWebsite.website.isFree) {
  //   } else {
  //     if (
  //       this.sharedPortalViewService.currentWebsite.website.isLinkedWithEmailService &&
  //       this.sharedPortalViewService.currentWebsite.website.isVerified &&
  //       this.userMailOptionsSize > 0
  //     ) {
  //       this.mailServiceStatus = MailServiceStatus.activated;
  //     } else if (
  //       this.sharedPortalViewService.currentWebsite.website.isLinkedWithEmailService &&
  //       !this.sharedPortalViewService.currentWebsite.website.isVerified &&
  //       this.userMailOptionsSize > 0
  //     ) {
  //       this.mailServiceStatus = MailServiceStatus.pending;
  //     } else if (
  //       !this.sharedPortalViewService.currentWebsite.website.isLinkedWithEmailService &&
  //       !this.sharedPortalViewService.currentWebsite.website.isVerified &&
  //       this.userMailOptionsSize > 0
  //     ) {
  //       this.mailServiceStatus = MailServiceStatus.configured;
  //     } else {
  //       this.mailServiceStatus = MailServiceStatus.not_configured;
  //     }
  //   }
  // }

  restoreCopyuserurl(objectID: string) {
    const copyBut = document.getElementById(objectID);
    // copyBut.setAttribute('style', 'background: transparent');
    copyBut.classList.value = '';
    copyBut.innerText = '';
  }
}
